/**
 * Tiny Web Audio cues for the per-question timer.
 *  - tick(): short soft click at 3s / 2s / 1s
 *  - whoosh(): downward sweep when time runs out
 *
 * Uses a single lazily-created AudioContext. Silent if the browser hasn't
 * had a user gesture yet (autoplay policy).
 */
let ctx = null;
let muted = false;

function getCtx() {
  if (muted) return null;
  if (ctx) return ctx;
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  try { ctx = new AC(); } catch { ctx = null; }
  return ctx;
}

function envelope(gain, attack = 0.005, release = 0.12) {
  const c = getCtx();
  if (!c) return;
  const now = c.currentTime;
  gain.gain.cancelScheduledValues(now);
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.25, now + attack);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + attack + release);
}

export function tick() {
  const c = getCtx();
  if (!c) return;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = "triangle";
  osc.frequency.setValueAtTime(880, c.currentTime);
  osc.connect(gain).connect(c.destination);
  envelope(gain, 0.003, 0.08);
  osc.start();
  osc.stop(c.currentTime + 0.1);
}

export function whoosh() {
  const c = getCtx();
  if (!c) return;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = "sawtooth";
  const now = c.currentTime;
  osc.frequency.setValueAtTime(440, now);
  osc.frequency.exponentialRampToValueAtTime(110, now + 0.35);
  osc.connect(gain).connect(c.destination);
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.18, now + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.4);
  osc.start();
  osc.stop(now + 0.42);
}

export function setMuted(v) { muted = !!v; }
export function isMuted() { return muted; }
